import { useMemo } from 'react';
import { useVisibleSchedule } from '../../../data/hooks/schedule/useVisibleSchedule';
import { useEventSchedule } from '../../../data/hooks/schedule/useEventSchedule';
import { isSessionRound } from 'common-data-handling';

/**
 * Groups rounds
 * @param {number} eventId Event ID
 * @param {array} visibleItems Schedule items to group the rounds
 * @returns { round_id: {unfiltered: [...round program items], visible: [...round program items]}}
 */
export function useRounds(eventId, visibleItems) {
    const entireSchedule = useEventSchedule(eventId);

    return useMemo(
        () =>
            visibleItems.filter(isSessionRound).reduce((rounds, item) => {
                return {
                    ...rounds,
                    [item.id]: {
                        unfiltered: entireSchedule.filter((item2) => item2.round_id == item.id),
                        visible: visibleItems.filter((item2) => item2.round_id == item.id),
                    },
                };
            }, {}),
        [visibleItems, entireSchedule]
    );
}
